module.exports = __webpack_public_path__ + "media/images/ic-avatar-barra-03f3b55d9e659f716db6e2ad786b593e.png";